import { Link } from "react-router-dom";
import { CityPage, FAQ, CityProduct } from "./CityPage";
import { URLS } from "../../adds/product-links";

const products: CityProduct[] = [
  {
    title: "Stevig fietsslot",
    description:
      "Amsterdam staat bekend om fietsdiefstal. Een goed ringslot of kettingslot is aan te raden, zeker bij het Centraal Station.",
    url: URLS.lock,
  },
  {
    title: "Regenjas voor op de fiets",
    description:
      "Het Amsterdamse weer is grillig. Een ademende regenjas houdt je droog zonder te zweten.",
    url: URLS.raincoat,
  },
  {
    title: "Fietstassen",
    description:
      "Handig voor boodschappen, laptop of je spullen voor het werk als je door de stad fietst.",
    url: URLS.panniers,
  },
];

const faqs: FAQ[] = [
  {
    question: "Welke kant komt de wind meestal uit in Amsterdam?",
    answer:
      "In Amsterdam is de overheersende windrichting zuidwest. Dat betekent dat routes richting het oosten of noorden vaak met wind mee gaan, en routes naar het zuiden of westen juist tegenwind opleveren.",
  },
  {
    question: "Is fietsen naar Amsterdam-Noord zwaar vanwege de wind?",
    answer:
      "De pont over het IJ vaart over open water, waardoor je bijna altijd wat zijwind tegenkomt. Bij harde wind vanaf zee kan dit behoorlijk oplopen. Check voor je rit op hebiktegenwind.nl of je tegenwind hebt.",
  },
  {
    question: "Waarom waait het in Amsterdam vaak harder dan landinwaarts?",
    answer:
      "Amsterdam ligt dicht bij zee, waardoor kustwinden weinig obstakels hebben om de stad te bereiken. Vooral in de herfst en winter zorgt dit voor flinke windkracht in de stad.",
  },
];

export function Amsterdam() {
  return (
    <CityPage
      city="Amsterdam"
      title="Fietsweer Amsterdam | Heb ik tegenwind?"
      description="Plan je fietstocht in Amsterdam. Bekijk de windrichting, tegenwind en meewind langs je route door de stad en omgeving."
      path="/fietsweer/amsterdam"
      faqs={faqs}
      products={products}
    >
      <p>
        Amsterdam is een van de meest fiets-vriendelijke steden ter wereld,
        maar met de stad zo dicht bij zee heb je vaak met flinke wind te maken.
        Vooral langs de open grachten, over de bruggen en op de route naar
        Amsterdam-Noord via het IJ kan de wind stevig doorstaan. Met de
        fietsweer-tool check je in één oogopslag of je straks tegenwind hebt op
        jouw route.
      </p>

      <h3>Wind in Amsterdam: wat kun je verwachten?</h3>
      <p>
        De overheersende windrichting in Amsterdam is zuidwest. Dat betekent
        dat je 's ochtends richting het centrum of oosten meestal wind in de
        rug hebt, maar op de terugweg naar huis kun je rekenen op tegenwind.
        Bij harde wind vanaf zee, vooral in najaar en winter, is het
        oversteken van het IJ of fietsen langs de kade soms bijna onbegaanbaar.
      </p>

      <h3>Populaire fietsroutes in Amsterdam</h3>
      <ul>
        <li>
          <strong>Amsterdam Centraal → Amsterdam-Noord (via de pont):</strong>{" "}
          korte oversteek maar het open water zorgt voor stevige zijwind.
        </li>
        <li>
          <strong>Centrum → Amstelpark:</strong> langs de Amstel, met weinig
          beschutting tegen zuidwestenwind.
        </li>
        <li>
          <strong>Amsterdam → Zaandam:</strong> populaire ritje via de
          Haarlemmerweg of door Westerpark, vooral in open polderland veel
          wind.
        </li>
        <li>
          <strong>Amsterdam → Ouderkerk aan de Amstel:</strong> mooie route
          langs de Amstel, ook hier is tegenwind de meest voorkomende
          klacht.
        </li>
      </ul>

      <h3>Check de wind voor jouw Amsterdamse rit</h3>
      <p>
        Vul jouw startpunt en bestemming in op de{" "}
        <Link to="/">fietsweer-tool</Link> en zie direct hoeveel procent van je
        route je tegenwind, meewind of zijwind hebt. Handig voor het forenzen,
        een tochtje naar het strand, of een dagje naar Zaandam.
      </p>

      <h3>Meer lezen</h3>
      <ul>
        <li>
          <Link to="/tegenwind-tips">Hoe fiets je effectief tegen de wind in</Link>
        </li>
        <li>
          <Link to="/onstaan-van-wind">Hoe ontstaat wind?</Link>
        </li>
      </ul>
    </CityPage>
  );
}
